'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _style = require('../style');

var _reactRedux = require('react-redux');

var _panelsUi = require('panels-ui');

var _widgetsAction = require('../widgets/action');

var _widgetsAction2 = _interopRequireDefault(_widgetsAction);

var _widgetsInfo = require('../widgets/info');

var _widgetsInfo2 = _interopRequireDefault(_widgetsInfo);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _widgetsSponsor = require('../widgets/sponsor');

var _widgetsSponsor2 = _interopRequireDefault(_widgetsSponsor);

var TournamentCard = function TournamentCard(props) {
  return _react2['default'].createElement(
    _widgetsAction2['default'],
    { href: props.group.ref + '/', style: style.action },
    props.group.name
  );
};

exports.TournamentCard = TournamentCard;
var Tournament = function Tournament(props) {
  var content = props.tournament.active ? _react2['default'].createElement(
    'span',
    { style: style.content },
    props.tournament.groups.map(function (group, i) {
      return _react2['default'].createElement(TournamentCard, { tournamentId: props.tournament.id, group: props.groupsById[group], key: i });
    }),
    _react2['default'].createElement(
      _widgetsAction2['default'],
      { href: 'fixture/', style: style.action },
      'Fixture'
    ),
    _react2['default'].createElement(
      _widgetsAction2['default'],
      { href: 'la-final/', style: style.action },
      'La final'
    ),
    _react2['default'].createElement(
      'div',
      { style: style.infos },
      _react2['default'].createElement(_widgetsInfo2['default'], { type: 'address', text: props.club.address }),
      _react2['default'].createElement(_widgetsInfo2['default'], { type: 'email', text: props.club.email, style: style.info }),
      _react2['default'].createElement(_widgetsInfo2['default'], { type: 'phone', text: props.club.phone, style: style.info })
    )
  ) : _react2['default'].createElement(
    'span',
    { style: style.content },
    '¡El torneo aún no ha empezado!'
  );

  return _react2['default'].createElement(
    _panelsUi.Panel,
    { width: props.width, style: style.panel },
    _react2['default'].createElement(
      'h1',
      { style: style.title },
      _react2['default'].createElement(
        'span',
        null,
        'Campeonato abierto del'
      ),
      _react2['default'].createElement(
        'span',
        null,
        props.club.name
      )
    ),
    _react2['default'].createElement(_widgetsSponsor2['default'], _extends({}, props.sponsor, { colour: 'BLUE', style: style.sponsor })),
    content
  );
};

exports.Tournament = Tournament;
var style = {
  action: {
    borderColor: _style.BLUE_TRANSPARENT,
    color: _style.BLUE
  },
  content: {
    marginTop: 75
  },
  info: {
    marginTop: 5
  },
  infos: {
    marginTop: 75
  },
  panel: {
    backgroundColor: _style.WHITE_TRANSPARENT_65,
    color: _style.BLUE,
    fontFamily: _style.FONT,
    fontWeight: _style.FONT_LIGHT,
    paddingBottom: 200,
    paddingLeft: 35,
    paddingRight: 35
  },
  title: {
    fontSize: 20,
    fontWeight: _style.FONT_LIGHT,
    marginTop: 85,
    textTransform: 'uppercase'
  },
  sponsor: {
    marginTop: 25
  }
};

function mapStateToProps(state, props) {
  var tournament = state.tournaments.byId[props.tournamentId];

  return {
    club: state.tournaments.clubsById[props.tournamentId],
    groupsById: state.tournaments.groupsById,
    sponsor: state.tournaments.sponsorsById[tournament.sponsorId],
    tournament: tournament
  };
}

exports['default'] = _reactRedux.connect(mapStateToProps)(Tournament);